function isCount(value) {
  return Number.isSafeInteger(value) && value >= 0;
}

export function resolveSolverExecution(diagnostics = {}) {
  const trace = diagnostics.solver_execution;
  if (!trace || trace.version !== 1
    || !isCount(trace.ortools_call_count) || !isCount(trace.fallback_count)
    || typeof trace.ortools_duration_ms !== "number"
    || !Number.isFinite(trace.ortools_duration_ms) || trace.ortools_duration_ms < 0
    || !trace.fallback_types || typeof trace.fallback_types !== "object"
    || Array.isArray(trace.fallback_types)) return null;
  const counts = Object.values(trace.fallback_types);
  if (!counts.every(isCount)
    || counts.reduce((sum, count) => sum + count, 0) !== trace.fallback_count) return null;
  return trace;
}

export function buildSolverExecutionMetrics(diagnostics = {}) {
  if (diagnostics.action !== "optimize_truck_routes") return [];
  const trace = resolveSolverExecution(diagnostics);
  return [
    { key: "ortools-called", label: "OR-Tools appelé", count: trace?.ortools_call_count,
      note: "Appel réel au solveur de tournées, même sans solution ou en cas d’échec." },
    { key: "fallback-executed", label: "Repli exécuté", count: trace?.fallback_count,
      note: "Exécution d’un repli, même si son résultat n’a pas été retenu." },
  ].map(({ count, ...metric }) => ({
    ...metric, value: count == null ? "Non mesuré" : count > 0 ? "Oui" : "Non", tone: "neutral",
  }));
}

const OUTSIDE_SOLVER_PARTS = [
  ["local_repair", "réparation locale"],
  ["preload_reuse", "préchargement"],
  ["priority_insertion", "insertion prioritaire"],
  ["greedy_fallback", "glouton"],
  ["other", "autres passes"],
];

export function resolveSolverPlacementSummary(diagnostics = {}) {
  const summary = diagnostics?.local_patch?.details?.solver_placement_summary;
  if (!summary || summary.version !== 1
    || !isCount(summary.order_count) || !isCount(summary.ortools_routed_order_count)
    || !isCount(summary.outside_solver_order_count)
    || summary.ortools_routed_order_count > summary.order_count) return null;
  return summary;
}

// « Optimiser ce camion » : commandes routées par OR-Tools sur le total du camion.
export function buildSolverRoutingSummaryMetrics(diagnostics = {}) {
  if (diagnostics.action !== "optimize_truck_routes") return [];
  const summary = resolveSolverPlacementSummary(diagnostics);
  if (!summary) return [];
  const breakdown = summary.outside_solver_breakdown && typeof summary.outside_solver_breakdown === "object"
    ? summary.outside_solver_breakdown : {};
  const parts = OUTSIDE_SOLVER_PARTS
    .filter(([key]) => isCount(breakdown[key]) && breakdown[key] > 0)
    .map(([key, label]) => `${label} ${breakdown[key]}`);
  const excluded = isCount(summary.excluded_same_od_group_count) ? summary.excluded_same_od_group_count : 0;
  const unassigned = isCount(summary.unassigned_order_count) ? summary.unassigned_order_count : 0;
  const value = [
    `${summary.ortools_routed_order_count}/${summary.order_count}`,
    `hors solveur ${summary.outside_solver_order_count}${parts.length ? ` (${parts.join(", ")})` : ""}`,
    excluded === 1 ? "groupe même O/D exclu" : excluded > 1 ? `${excluded} groupes même O/D exclus` : null,
    unassigned > 0 ? `non planifiées ${unassigned}` : null,
  ].filter(Boolean).join(" · ");
  return [{
    key: "ortools-routing",
    label: "Routage OR-Tools",
    value,
    note: "Commandes placées par les routes OR-Tools sur le total du camion ; « hors solveur » : placées par une passe de réparation.",
    tone: summary.ortools_routed_order_count === summary.order_count ? "neutral" : "warning",
  }];
}
